import { DataTransferObject } from '@ecp-caf/common-structure';
import { RefStructureInfo as RefStructureInfo } from './ref-structure-info';
import { IExtendStrucutreType } from './data-type/i-extend-strucutre-type';

export class GspDataTransferObject extends DataTransferObject{

    constructor(){
        super();
        this.allStructuredTypes=this.allStructuredTypes||[];
        this.refStructureInfos=this.refStructureInfos||[];
    }
    id: string;
    code: string;
    name: string;
    description: string;
    compile:boolean;
    
    allStructuredTypes:Array<IExtendStrucutreType>;
    /**
     * æä»¶å¼ç¨çå¯¹è±¡åè¡¨ï¼ä»åç±»åæ°æ®ä¸­å¼ç¨ï¼
     */
    refStructureInfos: Array<RefStructureInfo>;

    tryAddRefInfos(refInfo:RefStructureInfo){
        if(this.refStructureInfos.length<=0){
            this.refStructureInfos.push(refInfo);
        }
        let index=this.refStructureInfos.findIndex(x=>x.structuredTypeId===refInfo.structuredTypeId);
        if(index==-1){
            this.refStructureInfos.push(refInfo);
        }
    }
} 